import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { AuthProvider } from './auth/AuthProvider';
import { RequireAdmin, RequireSignedIn, RequireStaff } from './auth/guards';
import { Layout } from './components/Layout';
import { AccountPage } from './pages/AccountPage';
import { ClientListPage } from './pages/ClientListPage';
import { ClientPage } from './pages/ClientPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { LoginPage } from './pages/LoginPage';
import { NoAccessPage } from './pages/NoAccessPage';
import { RenewalsPage } from './pages/RenewalsPage';
import { StaffPage } from './pages/StaffPage';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              path="/no-access"
              element={
                <RequireSignedIn>
                  <NoAccessPage />
                </RequireSignedIn>
              }
            />
            <Route
              path="/account"
              element={
                <RequireStaff>
                  <AccountPage />
                </RequireStaff>
              }
            />
            <Route
              path="/clients"
              element={
                <RequireStaff>
                  <ClientListPage />
                </RequireStaff>
              }
            />
            <Route
              path="/clients/new"
              element={
                <RequireStaff>
                  <ClientPage />
                </RequireStaff>
              }
            />
            <Route
              path="/clients/:id"
              element={
                <RequireStaff>
                  <ClientPage />
                </RequireStaff>
              }
            />
            <Route
              path="/renewals"
              element={
                <RequireStaff>
                  <RenewalsPage />
                </RequireStaff>
              }
            />
            <Route
              path="/staff"
              element={
                <RequireAdmin>
                  <StaffPage />
                </RequireAdmin>
              }
            />
            <Route path="*" element={<Navigate to="/clients" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
